import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./AskQuestion.css";
import { askQuestion } from "../../actions/question";

const AskQuestion = () => {
  const [questionTitle, setQuestionTitle] = useState("");
  const [questionBody, setQuestionBody] = useState("");
  const [questionTags, setQuestionTags] = useState("");

  // const currentUser = useSelector((state) => state.currentUserReducer);

  const User = useSelector((state) => state.currentUserReducer);

  const dispatch = useDispatch();

  // const [badge, setBadge] = useState("");

  // const questionsList = useSelector((state) => state.questionsReducer);
  const navigate = useNavigate();

  // const handleSubsc = (a) => {
  //   a = true;
  //   setTimeout(() => {
  //     navigate("/Auth");
  //   }, 3000);
  // };

  // const count = questionsList.data.filter((user) => user.upVote.length > 2);
  // console.log(count);

  // const badgeReceiver = count.filter((user) => user.userId === User.result._id);
  // console.log(badgeReceiver);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      askQuestion(
        {
          questionTitle,
          questionBody,
          questionTags,
          userPosted: User.result.name,
          userId: User?.result?._id,
        },
        navigate
      )
    );

    // const count = questionsList.data.filter((user) => user.upVote.length > 2);
    // console.log(count);

    // const badgeReceiver = count.filter(
    //   (user) => user.userId === User.result._id
    // );
    // console.log(badgeReceiver);

    // if (User !== null && badgeReceiver.length !== 0) {
    //   setBadge("Champion");
    //   alert("Congratulations, you got a badge - Champion");
    //   dispatch(giveBadge(User.result._id, { badge }));
    // }

    // console.log({ questionTitle, questionBody, questionTags });
    // const count = questionsList.data.filter(
    //   (user) => user.userPosted === User.result.name
    // );
    // if (count.length === 0) {
    //   dispatch(
    //     askQuestion(
    //       {
    //         questionTitle,
    //         questionBody,
    //         questionTags,
    //         userPosted: User.result.name,
    //         userId: User?.result?._id,
    //       },
    //       navigate
    //     )
    //   );
    // } else if (count.length > 0) {
    //   dispatch(
    //     askQuestion(
    //       {
    //         questionTitle,
    //         questionBody,
    //         questionTags,
    //         userPosted: User.result.name,
    //         userId: User?.result?._id,
    //       },
    //       navigate
    //     )
    //   );
    //   handleSubsc();
    //   if (count.length > 1 && count.length < 5) {
    //     handleSubsc(false);
    //   }
    // } else if (count.length > 5 && handleSubsc()) {
    //   localStorage.setItem("Subplan2", "Silver");
    //   dispatch(
    //     askQuestion(
    //       {
    //         questionTitle,
    //         questionBody,
    //         questionTags,
    //         userPosted: User.result.name,
    //         userId: User?.result?._id,
    //       },
    //       navigate
    //     )
    //   );
    //   handleSubsc();
    //   if (count.length > 5 && count.length < 10) {
    //     handleSubsc(false);
    //   }
    // } else if (count.length > 10 && silver === "Silver" && handleSubsc()) {
    //   localStorage.setItem("Subplan3", "Gold");
    //   dispatch(
    //     askQuestion(
    //       {
    //         questionTitle,
    //         questionBody,
    //         questionTags,
    //         userPosted: User.result.name,
    //         userId: User?.result?._id,
    //       },
    //       navigate
    //     )
    //   );
    //   handleSubsc();
    //   if (count.length > 10) {
    //     handleSubsc(false);
    //   }
    // } else {
    //   handleSubsc();
    // }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      setQuestionBody(questionBody + "\n");
    }
  };

  return (
    <div className="ask-question">
      <div className="ask-ques-container">
        <h1 className="ask-que-h1">Ask a public Question</h1>
        <h1>{questionBody}</h1>
        <form onSubmit={handleSubmit}>
          <div className="ask-form-container">
            <label htmlFor="ask-ques-title">
              <h4>Title</h4>
              <p>
                Be specific and imagine you're asking a question to another
                person
              </p>
              <input
                type="text"
                id="ask-ques-title"
                placeholder="e.g. Is there an R function for finding the index of an element in a vector?"
                onChange={(e) => setQuestionTitle(e.target.value)}
              />
            </label>
            <label htmlFor="ask-ques-body">
              <h4>Body</h4>
              <p>
                Include all the information someone would need to answer your
                question
              </p>
              <textarea
                type="text"
                id="ask-ques-body"
                cols="30"
                rows="10"
                onKeyDown={handleEnter}
                onChange={(e) => setQuestionBody(e.target.value)}
              ></textarea>
            </label>
            <label htmlFor="ask-ques-tags">
              <h4>Tags</h4>
              <p>Add up to 5 tags to describe what your question is about</p>
              <input
                type="text"
                id="ask-ques-tags"
                placeholder="e.g. (xml typescript wordpress)"
                onChange={(e) => setQuestionTags(e.target.value.split(" "))}
              />
            </label>
          </div>
          <input
            type="submit"
            className="review-btn"
            value="Review your question"
          />
        </form>
      </div>
    </div>
  );
};

export default AskQuestion;
